import React from 'react';

const FastCall = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M92.14 59v42.956A6.044 6.044 0 0 1 86.096 108H38.544a6.044 6.044 0 0 1-6.044-6.044V18.044A6.044 6.044 0 0 1 38.544 12h47.552a6.044 6.044 0 0 1 6.044 6.044V22'
        stroke='#000'
        strokeWidth='4.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <ellipse cx='62.319' cy='93.992' rx='3.976' ry='4' transform='rotate(-180 62.319 93.992)' fill='var(--theme-primary, #810ea9)' />
      <path
        d='M31.87 51.555C22.463 60.873 9.527 78.88 22.002 82.07c15.595 3.988 72.223-36.98 83.41-52.86m0 0L84.75 32.736m20.662-3.526-4.041 21.657'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='4.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M32.5 46v16.5' stroke='#000' strokeWidth='4.4' />
    </svg>
  );
};

export default FastCall;
